export const useCategoryTemplate = async () => {
  const nuxtApp = useNuxtApp();
  const pageUrl = useGetPageUrl({ encode: true });

  const data: Record<string, any> = {};

  const { data: nodes, error } = await useAsyncData(() => nuxtApp.$api.getNodes(unref(pageUrl)));
  data.nodes = nodes;

  // TODO: Error handling should be obsolete, getNodes should always resolve with an (empty) object
  // Reset in case of error
  if (unref(error)) {
    data.nodes = null;
  }

  // Set breadcrumbs (normally 1 per category page)
  if (data.nodes) {
    data.breadcrumbs = [
      {
        id: data.nodes.id,
        title: data.nodes.title,
        url: data.nodes.url,
      },
    ];
  }

  return data;
};
